/* eslint-disable @angular-eslint/component-class-suffix */
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AutoUnsubscribe } from 'projects/cupcake/src/app/core/auto-unsubscribe';
import { RequestTypeEnum } from 'projects/cupcake/src/app/shared/xatena-api/request-type';
import { RequestProductDto } from 'projects/cupcake/src/app/xatena-api';
import { SubSink } from 'subsink';
import { RequestProductDeleteDialogComponent } from '../../request-product-delete-dialog/request-product-delete-dialog.component';
import { RequestProductEditDialogComponent } from '../../request-product-edit-dialog/request-product-edit-dialog.component';
import { FormlyRequestProductsService } from '../formly-request-products.service';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@AutoUnsubscribe()
@Component({
  selector: 'app-ag-grid-request-product-action-renderer',
  templateUrl: './ag-grid-request-product-action-renderer.component.html',
  styleUrls: ['./ag-grid-request-product-action-renderer.component.scss'],
  standalone: true,
  imports: [MatIconButton, MatTooltip, MatIcon, TranslateModule],
})
export class AgGridRequestProductActionRenderer
  implements ICellRendererAngularComp
{
  subs = new SubSink();

  constructor(
    private requestProductsService: FormlyRequestProductsService,
    private spinnerService: NgxSpinnerService,
    private dialog: MatDialog
  ) {}

  private requestProductId?: number;
  private data?: RequestProductDto;
  private fields?: string[];

  isReadOnly = false;

  onDeleteClicked() {
    const dialogRef = this.dialog.open(RequestProductDeleteDialogComponent, {
      data: {
        requestId: this.data?.requestId,
        requestProductId: this.requestProductId,
      },
    });

    this.subs.sink = dialogRef.afterClosed().subscribe(() => {
      this.requestProductsService.refreshRowDataCache();
    });
  }

  onEditClicked() {
    const dialogRef = this.dialog.open(RequestProductEditDialogComponent, {
      data: {
        requestId: this.data?.requestId,
        requestProductId: this.requestProductId,
        currency: this.requestProductsService.currency$.value,
        fields: this.fields,
        requestTypeId:
          this.requestProductsService.requestTypeId$?.value ??
          RequestTypeEnum.CatalogProduct,
      },
    });

    this.subs.sink = dialogRef.afterClosed().subscribe(() => {
      this.requestProductsService.refreshRowDataCache();
    });
  }

  onCloneClicked() {
    if (this.requestProductId) {
      this.spinnerService.show();
      this.subs.sink = this.requestProductsService
        .cloneProduct(this.requestProductId)
        .subscribe(() => this.spinnerService.hide());
    }
  }

  agInit(params: ICellRendererParams): void {
    this.isReadOnly = params.context.readOnly;

    this.data = params.data as RequestProductDto;
    this.requestProductId = params.value;
    this.fields = (params.api.getColumns() ?? [])
      .map(m => m.getColDef())
      .map(m => m.field ?? '');
  }

  refresh(params: ICellRendererParams) {
    this.isReadOnly = params.context.readOnly;
    return false;
  }
}
